import { useMemo } from 'react';

import useMultiAccounts from './useMultiAccounts';

const useMultiAccount = (multiAccountRef = '') => {
  const {
    state,
    selectors: { selectMultiAccount },
  } = useMultiAccounts();

  return useMemo(
    () => selectMultiAccount(state, multiAccountRef),
    [state, multiAccountRef, selectMultiAccount],
  );
};

export default useMultiAccount;
